<template>
  <div :data-id="id" class="flex flex-col gap-4">
    <div :data-id="id" class="sticky top-0 z-10 bg-pure-white">
      <div :data-id="id" class="flex flex-col gap-3 px-6 py-5">
        <div :data-id="id" class="flex flex-col gap-2">
          <div
            :data-id="id"
            v-if="appointment.client && appointment.client.name"
            class="flex items-center justify-between gap-4"
            :title="`Appointment for ${appointment.client.name}`"
          >
            <BlTextSubtitle1
              :data-id="id"
              :text="`Appointment for ${appointment.client.name}`"
              class="truncate"
            />
            <BlIcon icon="close" color="slate-6" class="w-6 h-6" clickable />
          </div>
          <BlTextBody2
            :data-id="id"
            v-if="appointment.client && appointment.client.name"
            :title="`You're viewing an appointment for ${appointment.client.name}.`"
            :text="`You're viewing an appointment for ${appointment.client.name}.`"
            class="truncate"
          />
        </div>
        <SlotDetails
          :data-id="id"
          :id="id"
          :appointment="appointment"
          asHeader
          useAction
          @open-cancellation="cancelOpened = true"
          @open-reschedule="rescheduleOpened = true"
          @after-commit="$emit('after-commit')"
        />
      </div>
      <div :data-id="id" class="flex-shrink-0 w-full h-5 bg-slate-200"></div>
    </div>
    <div :data-id="id" class="flex flex-col px-6">
      <div :data-id="id" class="flex flex-col gap-1 mb-1">
        <BlTextSubtitle2
          :data-id="id"
          text="All upcoming scheduled appointments for this client"
        />
        <BlTextBody2
          :data-id="id"
          v-if="appointment.client && appointment.client.name"
          :text="
            `${appointment.upcoming_appointments.length} scheduled appointment(s) for ${appointment.client.name}.`
          "
          class="truncate"
        />
      </div>
      <div
        v-for="item in appointment.upcoming_appointments"
        :data-id="id"
        :key="item.id"
        class="flex flex-col gap-4 mb-4"
      >
        <SlotDetails
          :data-id="id"
          :id="id"
          :appointment="item"
          useAction
          @open-cancellation="cancelOpened = true"
          @open-reschedule="rescheduleOpened = true"
          @after-commit="$emit('after-commit')"
        />
        <div
          :data-id="id"
          class="h-0.5 w-full flex-shrink-0 bg-slate-300"
        ></div>
      </div>
    </div>

    <CancelAppointmentModal
      v-if="cancelOpened && currentUser.role.includes('admin')"
      :appointmentId="appointment.id"
      @close-modal="cancelOpened = false"
      @after-commit="$emit('after-commit')"
    />

    <RescheduleAppointmentOverlay
      v-if="rescheduleOpened && currentUser.role.includes('admin')"
      :appointmentId="appointment.id"
      @close-modal="rescheduleOpened = false"
      @after-commit="$emit('after-commit')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

import SlotDetails from "./SlotDetails.vue";
import CancelAppointmentModal from "../modal/CancelAppointmentModal.vue";
import RescheduleAppointmentOverlay from "../overlay/RescheduleAppointmentOverlay.vue";

import BlTextTitle4 from "../../BlTextTitle4.vue";
import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlTextSubtitle2 from "../../BlTextSubtitle2.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlTextBody3 from "../../BlTextBody3.vue";
import BlIcon from "../../BlIcon.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "UpcomingAppointments",
  components: {
    SlotDetails,
    CancelAppointmentModal,
    RescheduleAppointmentOverlay,
    //
    BlTextTitle4,
    BlTextSubtitle1,
    BlTextSubtitle2,
    BlTextBody2,
    BlTextBody3,
    BlIcon,
    BlInputButton
  },
  props: {
    id: { type: String },
    appointment: { type: Object, default: null }
  },
  data() {
    return {
      menuOpened: false,
      cancelOpened: false,
      rescheduleOpened: false
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "currentCenter"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    }
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions([""]),
    displayDate(date) {
      return moment(date).format("dddd, DD MMM YYYY");
    },
    getSlotCount(start, end) {
      const s = start.split(":").map(i => Number(i));
      const e = end.split(":").map(i => Number(i));
      let slots = 0;
      slots += (e[0] - s[0]) * 2;
      if (s[1] === 30) slots -= 1;
      if (e[1] === 30) slots += 1;
      return slots;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/timeslot/UpcomingAppointments.vue